/**
 * Theme.js
 */
import on from 'dom-event'
import init, {idle} from '@/scripts/init'
import '../../modules/predictive-search/predictive-search'
import '../../modules/quantity-input/quantity-input'
import '../../modules/cart-item/cart-item'
import '../../modules/cart-gift/cart-gift'
import '../../modules/switch-to-subscription/switch-to-subscription'
import '../../modules/buy-more-save-more/buy-more-save-more'
import '../../modules/cart-recommended-product/cart-recommended-product'

import AOS from 'aos'

document.addEventListener('DOMContentLoaded', async () => {
  AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 200, // offset (in px) from the original trigger point
    delay: 100, // values from 0 to 3000, with step 50ms
    duration: 800, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: true, // whether elements should animate out while scrolling past them
    anchorPlacement: 'bottom-bottom', // defines which position of the element regarding to window should trigger the animation
  })
  init().mount()
  on(document.body, 'WheelBarrow.ReInitModules', (data) => {
    init('modules', data.detail).mount()
  })
  on(document.body, 'refreshAOS', () => AOS.refresh())

  await idle()
  import('../scripts/klaviyo')
  import('../scripts/accessibility')
  import('../scripts/scroll-trigger-animation')
})
